import { fetchPPPDetailQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';
import type { UsePPPDetailQueryProps } from './usePPPDetailQuery.types';

export const usePPPDetailQuery = ({ pppId }: UsePPPDetailQueryProps = {}) => {
	const { axiosInstance } = useAxiosInstance();
	return usePoQuery({
		queryKey: ['pppDetail', pppId],
		queryFn: () =>
			pppId ? fetchPPPDetailQuery(axiosInstance, pppId) : undefined,
		enabled: !!pppId,
	});
};
